import theme from 'styled-theming';
/** The mode context */
export type ModeProps = 'light' | 'dark';
export type ModeConfigProps = Record<ModeProps, string>;

export const setTheme = (v: ModeConfigProps) => {
  return theme('mode', v);
};
